import gql from 'graphql-tag';

export const EDIT_TEXT_ASSET_FOR_ARTICLE_GROUP_MUTATION = gql`
  mutation EditTextAssetForArticleGroupMutation(
    $articleGroupId: ID!
    $textAssetId: ID!
    $assetType: AssetTypeEnum!
    $text: String!
    $engagementScore: Int
    $postMaloneProjectId: ID
  ) {
    editTextAssetForArticleGroup(
      articleGroupId: $articleGroupId
      textAssetId: $textAssetId
      assetType: $assetType
      text: $text
      engagementScore: $engagementScore
    ) {
      textAsset {
        id
        text
        postMaloneScore(postMaloneProjectId: $postMaloneProjectId) {
          engagementScore
          sourceType
        }
      }
      errors
    }
  }
`;
